import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Loading } from 'entoro-shared';
import Typography from 'material-ui/Typography';
import withLayout from '../withLayout';
import { offerPreviewQuery } from '../../apollo';
import OfferDocuments from '../OfferOverview/OfferDocuments';
import OfferMedia from '../OfferOverview/OfferMedia';
import CompanySummary from '../OfferOverview/CompanySummary';
import ManagementTeam from '../OfferOverview/ManagementTeam';
import OfferDetails from '../OfferOverview/OfferDetails';
import OfferHighlights from '../OfferOverview/OfferHighlights';
import OfferFAQs from '../OfferOverview/OfferFAQs';
import { NavHashLink as NavLinks } from 'react-router-hash-link';
import YoutubeBackground from 'react-youtube-background';
import OfferPresentation from '../OfferOverview/OfferPresentation';

import OfferDetailsFund from '../OfferOverview/OfferDetailsFund';

class OfferPreview extends React.Component {
  state = {
    showPosition: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = (e) => {
    if (window.pageYOffset > 443) {
      this.setState({ showPosition: true });
    } else {
      this.setState({ showPosition: false });
    }
  };
  render() {
    const { data, tenant } = this.props;
    if (data.loading) {
      return <Loading />;
    }
    const { offerPreview: offer } = data;

    if (!offer) {
      return (
        <div className='grey-section-full'>
          <div className='max-width-div-center'>
            <div className='text-block-4-copy'>
              Offer preview not available.
            </div>
          </div>
        </div>
      );
    }

    const {
      videoFiles,
      documents,
      faqs,
      issuerCompany,
      headerImageUrl,
      listingType,
      headerType,
      headerVideoId,
      offerPresentationUrl,
      enableOfferPresentation,
      offerPresentationTitle,
    } = offer;

    const videoOptions = {
      width: 1200,
      height: 500,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        autohide: 1,
        showinfo: 0,
        loop: 1,
        modestbranding: 0,
        mute: 1,
        fs: 1, // Hide the full screen button
        cc_load_policy: 1, // Hide closed captions
        iv_load_policy: 3, // Hide the Video Annotations
      },
    };

    if (headerVideoId && headerVideoId.includes('youtube')) {
      //Sort the videoId from youtube link using regex
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = headerVideoId.match(regExp);
      var videoId = match && match[7].length == 11 ? match[7] : false;
    }
    return (
      <div>
        {headerType === 'IMAGE' || !headerType ? (
          <div
            className='hero-section-inner-page services'
            style={{
              backgroundImage: `linear-gradient(3deg, rgba(0, 0, 0, .14), rgba(51, 51, 51, .11) 25%, hsla(0, 0%, 100%, 0)), linear-gradient(180deg, rgba(12, 51, 97, .49), rgba(12, 51, 97, .49)), url(${headerImageUrl})`,
              backgroundPosition: 'center',
              marginTop: 65,
            }}
          >
            <div className='hero-wrapper inner-page' data-ix='nav-scroll'>
              <h1 className='title' data-ix='home-title-animate-inner-page'>
                {issuerCompany.name}
              </h1>
            </div>
          </div>
        ) : (
          <header>
            {videoId ? (
              <YoutubeBackground
                videoId={videoId}
                // aspectRatio='2.35.1'
                // overlay="rgba(0,0,0,.3)"
                playerOptions={videoOptions}
                className='video-background'
              />
            ) : (
              <video
                playsInline='playsinline'
                autoPlay='autoplay'
                muted='muted'
                loop='loop'
              >
                <source src={headerVideoId} type='video/mp4' />
              </video>
            )}

            <div className='hero-wrapper inner-page' data-ix='nav-scroll'>
              {/* <h1 className="title" data-ix="home-title-animate-inner-page">
                {issuerCompany.name}
              </h1> */}
            </div>
          </header>
        )}

        <div
          className={`nav-submenu ${
            this.state.showPosition ? 'positionAbs' : ''
          }`}
        >
          <div
            className={` notice-wrapper ${
              this.state.showPosition ? 'positionFixed' : ''
            }`}
          >
            <Typography className='notice-text' type='body1' align='center'>
              You are viewing a preview of this offer
            </Typography>
          </div>
          <nav
            className={`nav-menu-3 w-nav-menu res-nav ${
              this.state.showPosition ? 'positionFixed' : ''
            }`}
            style={{
              transform: 'translateY(0px) translateX(0px)',
              width: '100%',
              zIndex: 1000,
              marginTop: '15px',
              background: '#F0F0F0',
              transition: 'transform 400ms ease 0s',
            }}
          >
            <NavLinks
              to='#offerdetail'
              activeClassName='dash-current-page'
              className={`nav-link w-nav-link `}
              style={{ width: '10%' }}
            >
              Offer Details
            </NavLinks>

            <NavLinks
              to='#highlight'
              activeClassName='dash-current-page'
              className={`nav-link w-nav-link `}
              style={{ width: '10%' }}
            >
              Highlights
            </NavLinks>
            <NavLinks
              to='#company'
              activeClassName='dash-current-page'
              className={`nav-link w-nav-link `}
              style={{ width: '10%' }}
            >
              Company Summary
            </NavLinks>
            {Boolean(enableOfferPresentation && offerPresentationUrl) && (
              <NavLinks
                to='#presentation'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Presentation
              </NavLinks>
            )}
            {Boolean(
              (documents && documents.length) ||
                (videoFiles && videoFiles.length)
            ) && (
              <NavLinks
                to='#documents'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Documents & Media
              </NavLinks>
            )}
            {Boolean(issuerCompany.users && issuerCompany.users.length) && (
              <NavLinks
                to='#management'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Management Team
              </NavLinks>
            )}
            {Boolean(faqs && faqs.length) && (
              <NavLinks
                to='#faq'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                FAQ
              </NavLinks>
            )}
          </nav>
        </div>
        <div className='section'>
          <div className='max-width-div'>
            {listingType == 'FUNDS' ? (
              <OfferDetailsFund
                OfferName={offer.name}
                CompanyName={offer.issuerCompany.name}
                offer={offer}
              />
            ) : (
              <OfferDetails
                OfferName={offer.name}
                CompanyName={offer.issuerCompany.name}
                offer={offer}
              />
            )}
          </div>
          <OfferHighlights offer={offer} />
          <div className='sub-section' id='company'>
            <CompanySummary {...issuerCompany} />
          </div>
          <div className='sub-section' id='presentation'>
            {Boolean(offerPresentationUrl && enableOfferPresentation) && (
              <OfferPresentation
                offerPresentationTitle={offerPresentationTitle}
                offerPresentationUrl={offerPresentationUrl}
              />
            )}
          </div>
        </div>

        {(Boolean(documents.length) ||
          Boolean(videoFiles && videoFiles.length)) && (
          <div className='grey-section'>
            <OfferDocuments documents={documents} />
            <OfferMedia videoFiles={videoFiles} />
          </div>
        )}

        {Boolean(issuerCompany.users.length) && (
          <div className='grey-section'>
            <ManagementTeam users={issuerCompany.users} />
          </div>
        )}
        {Boolean(faqs && faqs.length) && (
          <div
            className={
              issuerCompany.users && issuerCompany.users.length
                ? 'section'
                : 'grey-section'
            }
          >
            <OfferFAQs faqs={faqs} />
          </div>
        )}
      </div>
    );
  }
}

OfferPreview.propTypes = {
  data: PropTypes.object.isRequired,
};

const withNotice = (Component) => (props) =>
  (
    <Fragment>
      <Component {...props} />
    </Fragment>
  );

export default withNotice(
  withLayout(
    compose(
      graphql(offerPreviewQuery, {
        options: ({ match }) => ({
          variables: {
            _id: match.params.id,
          },
        }),
      })
    )(OfferPreview)
  )
);



// WEBPACK FOOTER //
// ./src/components/OfferPreview/index.js